import {
  NavigationEnd,
  Router,
  RouterEvent,
  RouterLink,
} from '@angular/router';
import {
  Component,
  OnInit,
  TemplateRef,
  ViewChildren,
  QueryList,
  ElementRef,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { DatePipe, JsonPipe, NgClass, NgFor } from '@angular/common';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  FormArray,
} from '@angular/forms';
import { BehaviorSubject, forkJoin, fromEvent, Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

// Libs
import { CalendarOptions } from '@fullcalendar/core'; // Correct import for CalendarOptions
import {
  FullCalendarComponent,
  FullCalendarModule,
} from '@fullcalendar/angular';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import moment from 'moment';
import {
  BsModalService,
  BsModalRef,
  ModalOptions,
  ModalDirective,
} from 'ngx-bootstrap/modal';
// import { CKEditorModule } from 'ckeditor4-angular';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

// Services
import { SchoolCalendarService } from 'src/app/services/api/school-calendar.service';
import { MomentService } from 'src/app/services/api/moment.service';
import { CommonService } from 'src/app/services/api/common.service';
import { SendMailComponent } from '../../producer/modals/send-mail/send-mail.component';
// Components
import { BookingConfrimModalComponent } from '../../producer/modals/booking-confrim-modal/booking-confrim-modal.component';
import { BookingService } from 'src/app/services/api/booking.service';
import { MixpanelService } from 'src/app/mixpanel.service';
import { SchoolData } from 'src/app/models/schoolUser';
import { TimepickerComponent } from 'ngx-bootstrap/timepicker';
import { InviteRequestTabComponent } from '../../producer/invite-request-tab/invite-request-tab.component';
import { ValidatedDictComponent } from '../../producer/validated-dict/validated-dict.component';
import {
  BsDaterangepickerInlineDirective,
  BsDatepickerInputDirective,
  BsDatepickerDirective,
} from 'ngx-bootstrap/datepicker';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';
import { SharedService } from 'src/app/services/api/message.service';
import { DirectivesModule } from 'src/app/directives.module';
import { CalendarService } from 'src/app/services/api/consumer/calendar.service';
import { AddNewModalComponent } from '../../producer/modals/add-new-modal/add-new-modal.component';
import { ChangeDetectorRef } from '@angular/core';

import { an, aR, co, el, S } from '@fullcalendar/core/internal-common';
import { QuickAvailabilityUpdateComponent } from "../quick-availability-update/quick-availability-update.component";
import { AvailabilityChartComponent } from "../availability-chart/availability-chart.component";
import { CommonModule } from '@angular/common';
import { StartEndTimePipe } from 'src/app/pipes/start_ent_time.pipe';
import { ArticleComponent } from '../../producer/article/article.component';
import { TeacherBookingService } from 'src/app/services/api/consumer/bookings.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  standalone: true,
  imports: [
    DirectivesModule,
    FormsModule,
    FullCalendarModule,
    ReactiveFormsModule,
    BsDatepickerInputDirective,
    BsDatepickerDirective,
    NgClass,
    ModalDirective,
    DatePipe,
    QuickAvailabilityUpdateComponent,
    AvailabilityChartComponent,
    CommonModule,
    StartEndTimePipe,
    ArticleComponent
  ],
})
export class CalendarComponent implements OnInit {
  bookingDetails: any;
  public bsValue: any = '';
  @ViewChild('addExternalEvent') addExternalEvent: any;
  @ViewChild('bulkEditConfirmModal') bulkEditConfirmModal: any;
  @ViewChild('cancelReasonModal') cancelReasonModal: any;
  @ViewChild('exportModal') exportModal: any;
  @ViewChild('bookingExternalModal') bookingExternalModal: any;


  calendarOptions!: CalendarOptions;

  minDate: Date;
  maxDate: Date;
  bulkData: any;
  bulkDetails: Array<any> = [];
  selectAllAppCheck: boolean = false;
  filtersArray: any = [];
  defaultViewMonth: any = 'month';
  is_openCustomPicker: boolean = false;
  is_openCustomPickerRange: boolean = false;
  startTime: Date = new Date();
  endTime: Date = new Date();
  eventRangeValue: any;
  selectedEvent: any;
  public schoolProps!: SchoolData;
  showHiddenDiv: boolean = false;
  googleMapsUrl: SafeResourceUrl = '';
  reason_for_absence: String = 'Sick Leave';
  lrtDrtSelectedDates: any[] = []
  normalSelectedDates: any[] = []
  roasterUnavailableSelectedDates: any[] = [];
  isOneDayBooking: boolean = false;
  bookingListPerDay: any;
  // Half-day (half-day-am / half-day-pm) rows removed per-date from the LRT/DRT panel display & payload
  removedLrtDrtHalves: { [date: string]: string[] } = {};
  // Same, for the "Revert contract days" (roster unavailable) panel
  removedRoasterUnavailableHalves: { [date: string]: string[] } = {};


  @ViewChild('customPickerDiv', { static: false }) customPickerDiv?: ElementRef;
  @ViewChild('eventDateRange', { static: false }) eventDateRange?: ElementRef;
  @ViewChild('customDatepickerExport', { static: false })
  customDatepickerExport?: ElementRef;
  @ViewChild('eventDateRangeExport', { static: false })
  eventDateRangeExport?: ElementRef;
  selectedEventID: any;
  details: any;
  updateType: any;
  showAvailabilityModal: boolean = false;
  datesToShow: any;
  selectedModalDates: any;
  stats: any;
  showSideDate: any;
  externalBookingDetails: any;
  bookingDatas: any;
  bookingTabDetails: any = '';
  cancelBookingState: boolean = false;
  showHalfDayBookings: boolean = false;
  whichHalfDayBookings: string = '';
  public halfDayIndicated: any[] = [];
  timeCommitment: any;
  externalDate: any;
  current_month: any;
  availability_check: boolean = false;
  isContractTeacher: boolean = false;
  sideComponentData: any;

  constructor(
    private ngxService: NgxUiLoaderService,
    private CalendarService: CalendarService,
    private moment: MomentService,
    private commonservice: CommonService,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private bookingService: BookingService,
    private toastr: ToastrService,
    private commonService: CommonService,
    private _router: Router,
    private mixpanelService: MixpanelService,
    private renderer: Renderer2,
    private httpClient: HttpClient,
    private sharedService: SharedService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private teacherBookingService: TeacherBookingService,
  ) {
    this.minDate = new Date();
    // this.maxDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.minDate.setFullYear(this.minDate.getFullYear());
    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setFullYear(this.minDate.getFullYear());
    this.maxDate.setDate(this.maxDate.getFullYear());
    this.eventRangeValue = [this.startTime, this.endTime];

    this.renderer.listen('window', 'click', (e: Event | RouterEvent) => {
      if (
        e instanceof Event &&
        e.target !== this.customPickerDiv?.nativeElement &&
        e.target !== this.customDatepickerExport?.nativeElement
      ) {
        this.is_openCustomPicker = false;
      }
      // if (e.target !== this.eventDateRange?.nativeElement && e.target !== this.eventDateRangeExport?.nativeElement) {
      //   this.is_openCustomPickerRange = false;
      // }
    });
  }
  editBooking: boolean = false;
  public eventList: any;
  public selectedDate: any;
  bookingList: Array<any> = [];
  public calendarType = 'month';
  public startDate: any;
  public endDate: any;
  public submitted: boolean = false;
  public Desubmitted: boolean = false;
  public totalHoursBooking!: number;
  public totalBookings!: number;
  calendarMonthSelection: any;
  public myList: any;
  @ViewChild('bulkDataModal') bulkDataModal: any;
  @ViewChild('updateAvailabilityModal') updateAvailabilityModal: any;
  @ViewChild('recurringUpdateModal') recurringUpdateModal: any;
  @ViewChild('bookingsModal') bookingsModal: any;
  updateAvailabilityForm: FormGroup = this.fb.group({
    days: [''],
    availability: ['available'],
    time: ['full-day'],
    external_school: [''],
    external_contact: [''],
  });
  updateAvailabilityIndividualForm = this.fb.array([]); // FormArray

  addExternalEventForm: FormGroup = this.fb.group({
    title: ['', [Validators.required, Validators.minLength(6)]],
    start_end_date: [
      new Date(),
      [Validators.required, Validators.minLength(0)],
    ],
    comment: ['', [Validators.required, Validators.minLength(0)]],
    school_user_id: [''],
  });
  selectAllCheck: boolean = false;
  consumerDetails: Array<any> = [];
  hideButton: boolean = true;
  activeTab: boolean = true;
  content = '';
  calendarBookingFilterForm: FormGroup = this.fb.group({
    school: [''],
    select_date: [''],
  });
  getBulkDataForm: FormGroup = this.fb.group({
    filter_name: [''],
    from_date: [''],
    to_date: [''],
  });
  editBookings: FormGroup = this.fb.group({
    booking_teachercovered: [''],
    booking_classcovered: [''],
    booking_leaveapproved: [''],
    booking_notes: [''],
    booking_payrollfield1: [''],
    booking_payrollfield2: [''],
    booking_payrollfield3: [''],
    booking_absencereason: [''],
    line_item_ids: [''],
    action: [''],
  });
  recurringUpdateForm: FormGroup = this.fb.group({
    start_date: [''],
    recurrent_week: ['1'],
    end_date: [''],
    occurrence: ['0'],
    week_repeater: [''],
    occurrence_type: ['0'],
    // recurrent_occurrence: ['RECURRENT_WEEKLY'],
    recurrent_end: ['3'],
    // recurrent_occurrence: [''],
  });

  bookingExternalForm: FormGroup = this.fb.group({
    external_school: [''],
    external_contact: [''],
    id: [''],
    days: [''],
    availability: ['booked_externally'],
    time: [''],
  });
  public cancelBookingRequestForm!: FormGroup;
  public getExportForm!: FormGroup;
  public submittedInAppForm: boolean = false;
  public editType!: string;
  public updatePassword!: FormGroup;
  public updatePersonalInfo!: FormGroup;

  bsBulkFromValue: any = '';
  bsBulkToValue: any = '';
  config = {
    // extraPlugins: "autogrow",
    // resize_enabled: false,
    // autoGrow_maxHeight: 200,
    // autoGrow_maxWidth: 200,
    // removePlugins: "resize"
  };

  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;

  ShowLenghtError: any = 280;
  ShowLenght: any;
  classroomLimited: boolean = false;
  public selectedDates: string[] = [];
  individualAvailability: {
    [days: string]: {
      [key: string]: string | undefined; // <-- Add this line
      availability: string;
      time: string;
      external_school?: string;
      external_contact?: string;
    };
  } = {};

  // When a value changes in the template, update this object
  onIndividualAvailabilityChange(days: string, field: string, event: Event) {
    const target = event.target as HTMLInputElement | HTMLSelectElement;
    const value = target.value;
    if (!this.individualAvailability[days]) {
      this.individualAvailability[days] = { availability: '', time: '' };
    }
    this.individualAvailability[days][field] = value;
  }

  addSelectedDate(days: string) {
    // console.log('seelected dates before adding:', this.selectedDates);
    // console.log('individual availability before adding:', !this.selectedDates.includes(days));
    if (!this.selectedDates.includes(days)) {
      this.selectedDates.push(days);
      const isLrtDrt = this.lrtDrtSelectedDates?.length > 0;
      const isRoasterUnavailable = this.roasterUnavailableSelectedDates?.length > 0;

      let availability = isLrtDrt ? 'unavailable' : isRoasterUnavailable ? 'revert-back' : 'available'; // first option

      // For a split LRT/DRT or roster-unavailable day, prefill the editable half's
      // dropdown from that half's actual current status instead of the generic default.
      if (isLrtDrt || isRoasterUnavailable) {
        const actualStatus = this.getEditableHalfStatus(days);
        if (actualStatus === 'haventindicated') {
          availability = 'available';
        } else if (
          actualStatus === 'available' ||
          actualStatus === 'unavailable' ||
          actualStatus === 'booked_externally'
        ) {
          availability = actualStatus;
        }
      }

      this.individualAvailability[days] = {
        availability,
        time: 'full-day', // first option
        external_school: '', // default empty
        external_contact: '', // default empty
        reason_for_absence: isLrtDrt ? 'Sick leave' : '', // first option
      };
    }
  }

  // The status of the day's "open" (non-contract, non-roster-unavailable) half,
  // used to prefill the editable availability dropdown on a split day.
  private getEditableHalfStatus(date: string): string | undefined {
    const dayEvents = (this.eventList || []).filter(
      (event: any) =>
        moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === date
    );

    const editableEvent = dayEvents.find(
      (event: any) =>
        event.status !== 'Booked' &&
        event.status !== 'Cancelled' &&
        event.status !== 'externally_booked' &&
        event.status !== 'lrt_contract' &&
        event.status !== 'drt_contract' &&
        !(event.status === 'unavailable' && event?.from_roster === true)
    );

    return editableEvent?.status;
  }

  // Display-only breakdown of a selected LRT/DRT date into its half-day rows.
  // Does not affect individualAvailability / the payload sent to the API.
  getLrtDrtDayRows(date: string): {
    label: string;
    halfValue: string;
    isContract: boolean;
    statusLabel: string;
  }[] {
    const dayEvents = (this.eventList || []).filter(
      (event: any) =>
        moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === date
    );

    const isSplitDay = dayEvents.some(
      (event: any) =>
        event.booking_range === 'first_half' ||
        event.booking_range === 'second_half'
    );

    if (!isSplitDay) {
      const event = dayEvents[0];
      return [{
        label: 'Full day',
        halfValue: 'full-day',
        isContract: event?.status === 'lrt_contract' || event?.status === 'drt_contract',
        statusLabel: this.getEventStatusLabel(event?.status),
      }];
    }

    const visibleEvents = dayEvents.filter(
      (event: any) =>
        event.status !== 'Booked' &&
        event.status !== 'Cancelled' &&
        event.status !== 'externally_booked'
    );

    const removedHalves = this.removedLrtDrtHalves[date] || [];

    return visibleEvents
      .map((event: any) => ({
        label: event.booking_range === 'first_half' ? 'Half day AM' : 'Half day PM',
        halfValue: event.booking_range === 'first_half' ? 'half-day-am' : 'half-day-pm',
        isContract: event.status === 'lrt_contract' || event.status === 'drt_contract',
        statusLabel: this.getEventStatusLabel(event.status),
      }))
      .filter((row: { halfValue: string }) => !removedHalves.includes(row.halfValue));
  }

  // Remove a single half-day (AM/PM) row from a selected LRT/DRT date.
  // If both halves end up removed, the whole date is removed via removeSelectedDate.
  removeLrtDrtHalfDay(date: string, halfValue: string) {
    if (!this.removedLrtDrtHalves[date]) {
      this.removedLrtDrtHalves[date] = [];
    }
    if (!this.removedLrtDrtHalves[date].includes(halfValue)) {
      this.removedLrtDrtHalves[date].push(halfValue);
    }

    if (this.getLrtDrtDayRows(date).length === 0) {
      delete this.removedLrtDrtHalves[date];
      this.removeSelectedDate(date, '');
    }
  }

  private getEventStatusLabel(status: string | undefined, fromRoster?: boolean): string {
    switch (status) {
      case 'lrt_contract':
        return 'LRT Contract';
      case 'drt_contract':
        return 'DRT Contract';
      case 'haventindicated':
        return "Haven't indicated";
      case 'available':
        return 'Available';
      case 'unavailable':
        return fromRoster ? 'Contract Unavailable' : 'Unavailable';
      default:
        return status || '';
    }
  }

  // CSS modifier class for a status badge, matching the colors used on the calendar itself.
  getStatusBadgeClass(statusLabel: string): string {
    switch (statusLabel) {
      case 'LRT Contract':
        return 'is-lrt';
      case 'DRT Contract':
        return 'is-drt';
      case 'Available':
        return 'is-available';
      case 'Unavailable':
        return 'is-unavailable';
      case "Haven't indicated":
        return 'is-haventindicated';
      case 'Contract Unavailable':
        return 'is-contract-unavailable';
      default:
        return '';
    }
  }

  // Display-only breakdown of a selected "Revert contract days" date into its half-day rows.
  // Does not affect individualAvailability / the payload sent to the API.
  getRoasterUnavailableDayRows(date: string): {
    label: string;
    halfValue: string;
    isRoasterUnavailable: boolean;
    statusLabel: string;
  }[] {
    const dayEvents = (this.eventList || []).filter(
      (event: any) =>
        moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === date
    );

    const isSplitDay = dayEvents.some(
      (event: any) =>
        event.booking_range === 'first_half' ||
        event.booking_range === 'second_half'
    );

    if (!isSplitDay) {
      const event = dayEvents[0];
      return [{
        label: 'Full day',
        halfValue: 'full-day',
        isRoasterUnavailable: event?.status === 'unavailable' && event?.from_roster === true,
        statusLabel: this.getEventStatusLabel(event?.status, event?.from_roster),
      }];
    }

    const visibleEvents = dayEvents.filter(
      (event: any) =>
        event.status !== 'Booked' &&
        event.status !== 'Cancelled' &&
        event.status !== 'externally_booked'
    );

    const removedHalves = this.removedRoasterUnavailableHalves[date] || [];

    return visibleEvents
      .map((event: any) => ({
        label: event.booking_range === 'first_half' ? 'Half day AM' : 'Half day PM',
        halfValue: event.booking_range === 'first_half' ? 'half-day-am' : 'half-day-pm',
        isRoasterUnavailable: event.status === 'unavailable' && event.from_roster === true,
        statusLabel: this.getEventStatusLabel(event.status, event.from_roster),
      }))
      .filter((row: { halfValue: string }) => !removedHalves.includes(row.halfValue));
  }

  // Remove a single half-day (AM/PM) row from a selected "Revert contract days" date.
  // If both halves end up removed, the whole date is removed via removeSelectedDate.
  removeRoasterUnavailableHalfDay(date: string, halfValue: string) {
    if (!this.removedRoasterUnavailableHalves[date]) {
      this.removedRoasterUnavailableHalves[date] = [];
    }
    if (!this.removedRoasterUnavailableHalves[date].includes(halfValue)) {
      this.removedRoasterUnavailableHalves[date].push(halfValue);
    }

    if (this.getRoasterUnavailableDayRows(date).length === 0) {
      delete this.removedRoasterUnavailableHalves[date];
      this.removeSelectedDate(date, '');
    }
  }
  ngOnInit(): void {
    var date = new Date();
    const startToday = new Date();
    const endToday = new Date();

    this.recurringUpdateForm.get('occurrence')?.disable();

    this.recurringUpdateForm.patchValue({
      start_date: startToday,
      end_date: endToday,
    });
    this.recurringUpdateForm.patchValue({
      week_repeater: this.selected,
    });
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
    if (
      this.schoolProps.properties.is_classroom_teacher == true &&
      this.schoolProps.properties.is_admin == false
    ) {
      this.classroomLimited = true;
    }
    let startDate = this.moment.changeDateFormat(
      'ymd',
      new Date(date.getFullYear(), date.getMonth(), 1)
    );
    let endDate = this.moment.changeDateFormat(
      'ymd',
      new Date(date.getFullYear(), date.getMonth() + 1, 1)
    );
    this.ngxService.start();
    this.getFiltersData();
    this.formInit();
    this.checkLength();
    // this.getCalendarData(startDate, endDate);
    this.CalendarService.calendarAPI(startDate, endDate).subscribe({
      next: (res: any) => {
        if (res.status) {
          // console.log('k', res.data)
          this.eventList = res.data;
          this.availability_check = res.availability_check;
          this.isContractTeacher = res?.is_contract_teacher;
          this.setCalendatEvents(new Date());
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
    const today = new Date();
    const month = today.getMonth() + 1; // JS months are 0-based
    const year = today.getFullYear();
    const monthShort = today.toLocaleString('en-US', { month: 'short' }); // "Sep"
    this.current_month = `${monthShort}`;

    const formatted = today.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    this.showSideDate = formatted;
    this.teacherBookingService.getTeacherSideComponentAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.sideComponentData = res.data;
        } else {
          this.toastr.error(res.message || 'Failed to load side panel data');
        }
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error('Something went wrong');
      }
    });
    this.CalendarService.calendarStatsAPI(month, year).subscribe({
      next: (res: any) => {
        if (res.status) {
          // console.log('k', res.data)
          this.stats = res.data;
          this.setCalendatEvents(new Date());
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
    const startTime = new Date();
    startTime.setHours(8);
    startTime.setMinutes(0);
    const endTime = new Date();
    endTime.setHours(16);
    endTime.setMinutes(0);
    this.startTime = startTime;
    this.endTime = endTime;
    this.calendarOptions = {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: 'dayGridMonth',
      dayCellDidMount: this.accessibleDay.bind(this),
      // ...other options...
    };
    this.recurringUpdateForm.get('occurrence_type')?.valueChanges.subscribe(value => {
      this.occurrenceChange(value);
    });
  }
  removeAllSelectedDates() {
    this.selectedDates = [];
    this.individualAvailability = {};
    this.lrtDrtSelectedDates = [];
    this.normalSelectedDates = [];
    this.roasterUnavailableSelectedDates = [];
    this.selectedDate = moment().format('YYYY-MM-DD');
    this.bookingList = [];
    this.isBookedExternally = false;
    this.showHalfDayBookings = false;
    // this.checkEventsOnDateClick(this.eventList, this.selectedDate);
    this.showBookingDetailsForDate(this.selectedDate);
  }

  removeAllSelectedDatesLrtDrt() {
    this.selectedDates = [];
    this.lrtDrtSelectedDates = [];
    this.normalSelectedDates = [];
    this.roasterUnavailableSelectedDates = [];
    this.removedLrtDrtHalves = {};
    this.removedRoasterUnavailableHalves = {};

  }

  datesOnLoad() {    
    const calendarApi = this.calendarComponent.getApi();
    // Render the calendar
    calendarApi.render();

    // Render the calendar
    calendarApi.render();

    // Get the current date object from the calendar
    const currentDate = calendarApi.getDate();
    const year = currentDate.getFullYear();

    // Use this.current_month (e.g., "Sep") and current year to get the first day of that month
    // const year = new Date().getFullYear();
    const monthShort = this.current_month; // e.g., "Sep"
    // Convert short month name to month index (0-based)
    const monthIndex = new Date(`${monthShort} 1, ${year}`).getMonth();

    // Get start and end date for the selected month
    const startDateObj = new Date(year, monthIndex, 1);
    const endDateObj = new Date(year, monthIndex + 1, 1);

    let startDate = this.moment.changeDateFormat('ymd', startDateObj);
    let endDate = this.moment.changeDateFormat('ymd', endDateObj);


    this.CalendarService.calendarAPI(startDate, endDate).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.eventList = res.data;
          this.setCalendatEvents(new Date());
          // Select today's date
          this.selectedDate = moment().format('YYYY-MM-DD');
          this.bookingList = [];
          this.isBookedExternally = false;
          this.showHalfDayBookings = false;
          // this.checkEventsOnDateClick(this.eventList, this.selectedDate);
          this.showBookingDetailsForDate(this.selectedDate);
          // Remove all calendar event handlers
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
    this.teacherBookingService.getTeacherSideComponentAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.sideComponentData = res.data;
        } else {
          this.toastr.error(res.message || 'Failed to load side panel data');
        }
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error('Something went wrong');
      }
    });
    this.CalendarService.calendarStatsAPI(monthIndex, year).subscribe({
      next: (res: any) => {
        if (res.status) {
          // console.log('k', res.data)
          this.stats = res.data;
          this.setCalendatEvents(new Date());
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
    this.calendarOptions = {
      ...this.calendarOptions,
      dateClick: this.handleDateClick.bind(this),
      eventClick: (event: any) => this.evenetClick(event),
      select: this.handleDateSelect.bind(this),
      dayCellDidMount: this.accessibleDay.bind(this),
    };
  }
  refreshCalendar() {
    // Call your method to reload calendar data
    this.datesOnLoad();
  }
  getFiltersData() {
    this.commonService.schoolChoices('booking').subscribe({
      next: (res: any) => {
        this.filtersArray = res.choices;
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
  }

  accessibleDay(arg: any) {
    const el = arg.el;
    el.setAttribute('tabindex', '0');
    el.setAttribute('role', 'button');
    el.setAttribute('aria-label', `Date: ${arg.date.toDateString()}`);

    el.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        // console.log('Date clicked:', arg);
        this.handleDateClick(arg);
      }
    });
  }

  formInit() {
    this.cancelBookingRequestForm = this.fb.group({
      cancel_message: ['', [Validators.required, this.noWhitespaceValidator]],
      lineitem_id: [''],
    });
    this.getExportForm = this.fb.group({
      from_date: [''],
      to_date: [''],
    });
  }
  public noWhitespaceValidator(control: FormControl) {
    return (control.value || '').trim().length ? null : { whitespace: true };
  }

  resetCalendarOnEvent() {
    let currentUrl = this._router.url;
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate([currentUrl]);
    });
    // this.ngxService.start();
    // this.getFiltersData()
    // this.formInit()
    // this.checkLength()
    // var date = new Date();
    // let startDate = this.moment.changeDateFormat('ymd', new Date(date.getFullYear(), date.getMonth(), 1));
    // let endDate = this.moment.changeDateFormat('ymd', new Date(date.getFullYear(), date.getMonth() + 1, 0));
    // this.ngxService.start();
    // // this.getCalendarData(startDate, endDate);
    // this.calendarService.getCalendarData(startDate, endDate).subscribe({
    //   next: (res: any) => {
    //     console.log('k', res.data)
    //     this.eventList = res.data.bookings_events_list;
    //     this.totalHoursBooking = res.data.booked_hours;
    //     this.totalBookings = res.data.total_bookings;
    //     this.setCalendatEvents(new Date());
    //   },
    //   error: (err: any) => {
    //     console.log(err);
    //   }
    // });
  }

  setCalendatEvents(date: any) {
    this.selectedDate = new Date(date).toJSON().slice(0, 10).replace(/-/g, '-');
    // console.log('Selected Date:', this.selectedDate);
    const commonOptions = {
      plugins: [dayGridPlugin, interactionPlugin],
      selectable: true,
      select: this.handleDateSelect.bind(this), // <-- Add this line
      dateClick: this.handleDateClick.bind(this),
      eventClick: (event: any) => this.evenetClick(event),
      eventContent: this.renderEventContent.bind(this),
      events: this.eventList,
      dayCellDidMount: this.dayCellDidMount, // <-- Always include this!
    };
    // console.log('Event List:', this.eventList);

    if (this.calendarType == 'week') {
      this.calendarOptions = {
        ...commonOptions,
        initialView: 'dayGridMonth',
        firstDay: 1,
        weekends: true,
        duration: { days: 3 },
        dayHeaderContent: (args) => moment(args.date).format('ddd D'),
        headerToolbar: {
          left: 'myCustomButtonLeft',
          center: 'title',
          right: 'myCustomButtonRight',
        },
        customButtons: {
          myCustomButtonRight: {
            text: 'Next',
            click: this.handleNextMonthClick.bind(this),
          },
          myCustomButtonLeft: {
            text: 'Previous',
            click: this.handlePreviousMonthClick.bind(this),
          },
        },
        fixedWeekCount: false,
        showNonCurrentDates: false,
      };
    } else {
      this.calendarOptions = {
        ...commonOptions,
        initialView: 'dayGridMonth',
        duration: { days: 3 },
        dayHeaderContent: (args) => moment(args.date).format('dddd'),
        dayMaxEvents: 2,
        firstDay: 1,
        weekends: false,
        headerToolbar: {
          left: 'myCustomButtonLeft',
          center: 'title',
          right: 'myCustomButtonRight',
        },
        buttonText: {
          prev: 'Previous',
        },
        customButtons: {
          myCustomButtonRight: {
            text: 'Next',
            click: this.handleNextMonthClick.bind(this),
          },
          myCustomButtonLeft: {
            text: 'Previous',
            click: this.handlePreviousMonthClick.bind(this),
          },
        },
        fixedWeekCount: false,
        showNonCurrentDates: false,
      };
    }

    this.checkEventsOnDateClick(this.eventList, this.selectedDate);
  }
  renderContent(info: any) {
    console.log('l', info);
  }

  evenetClick(arg: any) {
    const eventStatus = arg.event._def.extendedProps.status;
    const eventDate = arg.event.start
      ? moment(arg.event.start).format('YYYY-MM-DD')
      : '';

    if (eventStatus === 'booked_externally') {
      this.externalBookingsPopUp(arg.event._def.extendedProps, '');
      return;
    }
    // Existing logic for other statuses
    if (eventStatus == 'Booked' || eventStatus == 'Cancelled') {
      this.bookingPopup(arg.event._def.extendedProps, '');
    } else if (eventStatus == 'casual_cancelled') {
      this.bookingPopup(arg.event._def.extendedProps, '');
    } else if (
      eventStatus === 'haventindicated' ||
      eventStatus === 'available' ||
      eventStatus === 'unavailable' ||
      eventStatus === 'drt_contract' ||
      eventStatus === 'lrt_contract'
    ) {
      // Your custom logic for these statuses
      // For example, select the date and show details
      // console.log('Event Date:', eventDate);
      this.handleDateSelect({ startStr: eventDate });
      if (eventDate) {
        // const index = this.selectedDates.indexOf(eventDate);
        // if (index === -1) {
        //   this.addSelectedDate(eventDate);
        // } else {
        // this.selectedDates.splice(index, 1);
        if (this.selectedDates.length === 0) {
          this.bookingList = [];
          this.showSideDate = '';
        } else {
          this.showBookingDetailsForDate(this.selectedDates[this.selectedDates.length - 1]);
        }
        // }
        this.cdr.detectChanges(); // <-- Add this line
        this.calendarComponent.getApi().render();
      }
    } else {
      this.externalEventPopup(arg);
    }
  }
  externalBookingsPopUp(bookingsData: any, edit: any) {
    // console.log('External Booking Data:', bookingsData);
    this.externalBookingDetails = bookingsData;
    this.bookingExternalForm.patchValue({
      external_school: bookingsData.external_booking.meta.school_name || '',
      external_contact: bookingsData.external_booking.meta.school_contact || '',
      id: bookingsData.external_booking.id || '',
    });
    if (bookingsData.booking_range == 'first_half') {
      this.timeCommitment = 'First half';
    } else if (bookingsData.booking_range == 'second_half') {
      this.timeCommitment = 'Second half';
    } else if (bookingsData.booking_range == 'full_day') {
      this.timeCommitment = 'Full day';
    }
    this.externalDate = bookingsData.date || '';
    this.bsModalRef = this.modalService.show(this.bookingExternalModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
  openBulkDetailModal() {
    this.bsModalRef = this.modalService.show(this.bulkDataModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }
  handleDateClick(arg: any) {
    // console.log('Date clicked:', arg?.dayEl?.textContent);
    // console.log('Date clicked (arg):', arg);
    // console.log(arg)
    this.selectedDate = arg.dateStr || arg.date;
    // this.bookingList = [];
    // this.checkEventsOnDateClick(this.eventList, arg.dateStr || arg.date);
  }

  isDateBooked(dateStr: string): boolean {
    // eventList should be an array of your events
    return this.eventList?.some(
      (event: any) =>
        // Compare in the same format as your event date
        moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === dateStr &&
        (event.status === 'Booked' || event.status === 'Cancelled')
    );
  }

  handleDateSelect(selectInfo: any) {
    this.bookingListPerDay = [];

    const selectedDate = selectInfo.startStr;

    this.showBookingDetailsForDate(selectedDate);

    const foundEvent = this.eventList.find((event: any) =>
      moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === selectedDate &&
      (event.status === 'lrt_contract' || event.status === 'drt_contract')
    );

    const foundEventNormal = this.eventList.find((event: any) =>
      moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === selectedDate &&
      event.status !== 'Booked' &&
      event.status !== 'Cancelled' &&
      event.status !== 'externally_booked' &&
      event?.from_roster !== true
    );

    const bookingList = this.eventList.find((event: any) =>
      moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === selectedDate &&
      (event.status === 'Booked' || event.status === 'Cancelled')
    );

    const roasterUnavailable = this.eventList.find((event: any) =>
      moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === selectedDate &&
      event.status === 'unavailable' &&
      event?.from_roster == true
    );

    if (bookingList) {
      if (!this.bookingListPerDay) {
        this.bookingListPerDay = [];
      }
      this.bookingListPerDay.push(bookingList);
    }

    const isLrtDrt =
      foundEvent?.status === 'lrt_contract' ||
      foundEvent?.status === 'drt_contract';
    const isRoasterUnavailable = !!roasterUnavailable;

    // A split day's "open" half (e.g. haventindicated/available) must not also be treated as a
    // normal selection when the other half is a roster-unavailable contract day, otherwise the
    // date gets pushed into both normalSelectedDates and roasterUnavailableSelectedDates, and a
    // later deselect click only clears one of them - leaving a stale entry that blocks other dates.
    const isNormal = foundEventNormal && !isLrtDrt && !isRoasterUnavailable;

    // ✅ -------------------------------
    // 🔥 HANDLE DESELECT FIRST (IMPORTANT)
    // -------------------------------

    // LRT/DRT deselect
    const recurringIndex = this.lrtDrtSelectedDates.findIndex((event: any) =>
      moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === selectedDate
    );

    if (isLrtDrt && recurringIndex !== -1) {
      this.lrtDrtSelectedDates.splice(recurringIndex, 1);
      this.selectedDates = this.selectedDates.filter(d => d !== selectedDate);
      this.refreshCalendarRoaster();
      return;
    }

    // Normal deselect
    const normalIndex = this.normalSelectedDates.findIndex((event: any) =>
      moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === selectedDate
    );

    if (isNormal && normalIndex !== -1) {
      this.normalSelectedDates.splice(normalIndex, 1);
      this.selectedDates = this.selectedDates.filter(d => d !== selectedDate);
      this.refreshCalendarRoaster();
      return;
    }

    // Roaster deselect
    const roasterIndex = this.roasterUnavailableSelectedDates.findIndex((event: any) =>
      moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === selectedDate
    );

    if (isRoasterUnavailable && roasterIndex !== -1) {
      this.roasterUnavailableSelectedDates.splice(roasterIndex, 1);
      this.selectedDates = this.selectedDates.filter(d => d !== selectedDate);
      this.refreshCalendarRoaster();
      return;
    }

    // 🚫 -------------------------------
    // 🔥 PREVENT MIXING
    // -------------------------------

    if (this.lrtDrtSelectedDates.length > 0 && isNormal) {
      this.toastr.warning('You cannot select normal dates after selecting LRT/DRT dates.');
      return;
    }

    if (this.normalSelectedDates.length > 0 && isLrtDrt) {
      this.toastr.warning('You cannot select LRT/DRT dates after selecting normal dates.');
      return;
    }

    if (
      (this.lrtDrtSelectedDates.length > 0 || this.normalSelectedDates.length > 0) &&
      isRoasterUnavailable
    ) {
      this.toastr.warning('You cannot select roster unavailable dates after selecting other dates.');
      return;
    }

    if (
      this.roasterUnavailableSelectedDates.length > 0 &&
      (isLrtDrt || isNormal)
    ) {
      this.toastr.warning('You cannot select other dates after selecting roster unavailable dates.');
      return;
    }

    // 🚫 No valid event
    if (!foundEvent && !foundEventNormal && !isRoasterUnavailable) {
      return;
    }

    // ✅ -------------------------------
    // 🔥 ADD SELECTION
    // -------------------------------

    if (isNormal) {
      this.normalSelectedDates.push(foundEventNormal);
    }

    if (isLrtDrt) {
      this.lrtDrtSelectedDates.push(foundEvent);
    }

    if (isRoasterUnavailable) {
      this.roasterUnavailableSelectedDates.push(roasterUnavailable);
    }

    // ✅ Manage selectedDates
    if (!this.selectedDates.includes(selectedDate)) {
      this.addSelectedDate(selectedDate);
    }

    this.refreshCalendarRoaster();
    // console.log('Selected Dates:', this.selectedDates);
    // console.log('LRT/DRT Dates:', this.lrtDrtSelectedDates);
    // console.log('Normal Dates:', this.normalSelectedDates);
    // console.log('Roaster Unavailable Dates:', this.roasterUnavailableSelectedDates);
  }

  refreshCalendarRoaster() {
    this.calendarOptions = {
      ...this.calendarOptions,
      dayCellDidMount: this.dayCellDidMount,
    };

    this.cdr.detectChanges();
    this.calendarComponent.getApi().render();
  }

  showBookingDetailsForDate(dateStr: string) {
    // Find all bookings for this date
    // console.log('Selected date:', dateStr);
    const eventsForDate =
      this.eventList?.filter(
        (event: any) =>
          moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === dateStr
      ) || [];

    // Booked events
    this.bookingList = eventsForDate.filter(
      (event: any) => event.status === 'Booked' || event.status === 'Cancelled'
    );

    // Other events (e.g., half-day indicated, casual cancelled, etc.)
    this.halfDayIndicated = eventsForDate.filter(
      (event: any) => event.status !== 'Booked'
    );

    // Optionally, handle half-day bookings display logic
    if (this.bookingList.some((e) => e.booking_range === 'full-day')) {
      this.showHalfDayBookingsFunc('');
      this.whichHalfDayBookings = '';
    } else if (
      this.bookingList.some((e) => e.booking_range === 'second-half')
    ) {
      this.showHalfDayBookingsFunc('second_half');
      this.whichHalfDayBookings = 'Second half';
    } else if (this.bookingList.some((e) => e.booking_range === 'first-half')) {
      this.showHalfDayBookingsFunc('first_half');
      this.whichHalfDayBookings = 'First half';
    }

    const dateString = dateStr;
    const dateObj = moment(dateString, 'YYYY-MM-DD').toDate();
    const formatted = dateObj.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    this.showSideDate = formatted;
    // console.log('Booking List:', this.bookingList);
    // console.log('Half Day Indicated:', this.halfDayIndicated);
    // Optionally, set a flag to open/show the side component
    // or whatever triggers your side component
  }
  showHalfDayBookingsFunc(half: string) {
    if (half === 'first_half') {
      this.showHalfDayBookings = true;
    } else if (half === 'second_half') {
      this.showHalfDayBookings = true;
    } else {
      this.showHalfDayBookings = false;
    }
    this.whichHalfDayBookings = half;
  }
  dayCellDidMount = (arg: any) => {
    // console.log('Event List jns:', this.eventList);
    // debugger;
    // console.log('dayCellDid:', arg.date);
    // Highlight selected dates

    const el = arg.el as HTMLElement;

    // ✅ HARD RESET – fixes DOM reuse bug
    el.classList.remove('selected-calendar-date');

    // Safety check
    if (!this.selectedDates || this.selectedDates.length === 0) {
      return;
    }

    // ✅ Always compute date fresh from cell
    const cellDateStr = arg.date.toISOString().slice(0, 10);

    // ✅ Apply highlight ONLY if explicitly selected
    if (this.selectedDates.includes(cellDateStr)) {
      el.classList.add('selected-calendar-date');
    }

    // Accessibility attributes (optional)
    arg.el.setAttribute('tabindex', '0');
    arg.el.setAttribute('role', 'button');
    arg.el.setAttribute('aria-label', `Date: ${arg.date.toDateString()}`);
    arg.el.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.handleDateClick(arg);
      }
    });
  };
  // dayCellDidMount = (arg: any) => {
  //   // console.log('Event List jns:', this.eventList);
  //   // debugger;
  //   // console.log('dayCellDid:', arg.date);
  //   // Highlight selected dates
  //   const dateStr = arg.date.toISOString().slice(0, 10);
  //   // console.log('Checking date:', dateStr, 'Selected dates:', this.selectedDates);
  //   if (this.selectedDates.includes(dateStr)) {
  //     // Find the highlight div inside the cell
  //     const highlightDiv = arg.el.querySelector('.fc-daygrid-day-frame');
  //     if (highlightDiv) {
  //       // console.log('Highlighting date:', highlightDiv);
  //       highlightDiv.classList.add('selected-calendar-date');
  //     }
  //     // Optionally, add to the cell itself
  //     arg.el.classList.add('selected-calendar-date');
  //   } else {
  //     const highlightDiv = arg.el.querySelector('.fc-daygrid-day-frame');
  //     if (highlightDiv) {
  //       highlightDiv.classList.remove('selected-calendar-date');
  //     }
  //     arg.el.classList.remove('selected-calendar-date');
  //   }
  //   // Accessibility attributes (optional)
  //   arg.el.setAttribute('tabindex', '0');
  //   arg.el.setAttribute('role', 'button');
  //   arg.el.setAttribute('aria-label', `Date: ${arg.date.toDateString()}`);
  //   arg.el.addEventListener('keydown', (e: KeyboardEvent) => {
  //     if (e.key === 'Enter' || e.key === ' ') {
  //       e.preventDefault();
  //       this.handleDateClick(arg);
  //     }
  //   });
  // };
  // Utility to select today's date if none selected
  private selectTodayIfNoneSelected() {
    if (!this.selectedDates || this.selectedDates.length === 0) {
      const todayStr = moment().format('YYYY-MM-DD');
      this.selectedDates = [todayStr];
      this.showBookingDetailsForDate(todayStr);
      this.calendarComponent.getApi().render();
    }
  }
  checkEventsOnDateClick(eventArray: any, selectedDate: any) {
    this.bookingList = [];
    if (!Array.isArray(eventArray)) {
      return;
    }
    const todayStr = moment(selectedDate).format('DD/MM/YYYY');
    // console.log('Today String:', todayStr);
    // console.log('Selected Date:', eventArray);
    for (let i = 0; i < eventArray.length; i++) {
      const eventDate = eventArray[i]['date'];
      const isBooked = eventArray[i]['status'] == 'Booked' || eventArray[i]['status'] == 'Cancelled';

      if (eventDate == todayStr && isBooked) {
        this.bookingList.push(eventArray[i]);
      }
      // console.log('Booking jdncjwd:', this.bookingList);
    }

    let dateBookings =
      this.bookingList?.length > 0 ? this.bookingList?.length : 'no';
    this.sharedService.announcement.next(
      dateBookings + ' bookings found for' + `Date: ${selectedDate}`
    );
    setTimeout(() => {
      this.sharedService.announcement.next('');
    }, 2000);
    this.ngxService.stop();
  }
  bookingPopup(bookingData: any, edit: any) {
    this.bookingDatas = bookingData;
    this.cancelBookingState = false;
    this.updateGoogleMapFromBooking();
    // console.log('Booking Data:', bookingData);
    this.bsModalRef = this.modalService.show(this.bookingsModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }

  showPopupForEvent(arg: any) {
    this.bookingPopup(arg, '');
  }

  externalEventPopup(arg: any) {
    this.selectedEventID = '';
    if (arg == '') {
      var startFrom = new Date();
      var endFrom = new Date();
      // Set hours
      startFrom.setHours(8);
      endFrom.setHours(16);
      // Then set minutes
      startFrom.setMinutes(0);
      endFrom.setMinutes(0);

      let startDate = moment(startFrom).format('DD/MM/YYYY hh:mm A');

      let endDate = moment(endFrom).format('DD/MM/YYYY hh:mm A');
      this.addExternalEventForm.patchValue({
        start_end_date: startDate + ' - ' + endDate,
      });
      this.bsModalRef = this.modalService.show(this.addExternalEvent, {
        class: 'modal-md',
        backdrop: 'static',
      });
    } else {
      // this.selectedEvent = arg;
      // this.selectedEventID = arg.event._def.publicId
      // this.eventRangeValue = [new Date(arg.event._def.extendedProps.event_date.start),
      // new Date(arg.event._def.extendedProps.event_date.end)];
      // this.startTime = new Date(new Date(arg.event._def.extendedProps.event_date.start));
      // this.endTime = new Date(new Date(arg.event._def.extendedProps.event_date.end));
      // let startDate = moment(arg.event._def.extendedProps.event_date.start).format('DD/MM/YYYY hh:mm A');
      // let endDate = moment(arg.event._def.extendedProps.event_date.end).format('DD/MM/YYYY hh:mm A');
      // this.addExternalEventForm.patchValue({
      //   title: arg.event._def.title,
      //   start_end_date: startDate + ' - ' + endDate,
      // })
      // this.bsModalRef = this.modalService.show(this.addExternalEvent, { class: 'modal-md', backdrop: 'static' });
    }
  }

  // GET EVENTS FROM CALENDER PREVIOUS CLICK
  handlePreviousMonthClick(): void {
    this.ngxService.start();
    let calendarApi = this.calendarComponent.getApi();
    calendarApi.prev();
    const viewDate = calendarApi.getDate();
    let getDates =
      this.calendarType == 'month'
        ? this.monthStartEndDate(viewDate)
        : this.weekStartEndDate(viewDate);
    const defaultDate =
      this.calendarType == 'month'
        ? this.getDefaultSelectedDate(viewDate)
        : getDates.startDate;
    this.getCalendarData(getDates.startDate, getDates.endDate, defaultDate);
  }

  // GET EVENTS FROM CALENDER NEXT CLICK
  handleNextMonthClick(): void {
    this.ngxService.start();
    let calendarApi = this.calendarComponent.getApi();
    calendarApi.next();
    const viewDate = calendarApi.getDate();
    let getDates =
      this.calendarType == 'month'
        ? this.monthStartEndDate(viewDate)
        : this.weekStartEndDate(viewDate);
    const defaultDate =
      this.calendarType == 'month'
        ? this.getDefaultSelectedDate(viewDate)
        : getDates.startDate;
    this.getCalendarData(getDates.startDate, getDates.endDate, defaultDate);
  }

  // Default date to select when landing on a month: today's date if the navigated-to
  // month is the current month, otherwise the first Monday-to-Friday day of that month
  // (never a weekend).
  private getDefaultSelectedDate(date: any): string {
    const viewMoment = moment(date);
    const today = moment();
    if (viewMoment.year() === today.year() && viewMoment.month() === today.month()) {
      return today.format('YYYY-MM-DD');
    }

    let d = viewMoment.clone().startOf('month');
    while (d.day() === 0 || d.day() === 6) {
      d.add(1, 'day');
    }
    return d.format('YYYY-MM-DD');
  }

  editBookingSec() {
    this.editBooking = !this.editBooking;
  }
  selectAllApp(type: any, event: any) {
    var checked = event.target.checked;
    if (this.classroomLimited) {
      if (type == 'All') {
        this.bulkDetails = [];
        this.bulkData.forEach((x: any) => {
          if (checked) {
            if (x.is_classroomteacher_booking_check) {
              x.isChecked = true;
              this.bulkDetails.push(x);
              this.hideButton = false;
            }
          } else {
            this.hideButton = true;
            x.isChecked = false;
            this.bulkDetails = [];
          }
        });
      } else {
        if (checked) {
          type.isChecked = true;
          this.bulkDetails.push(type);
          this.hideButton = false;
        } else {
          type.isChecked = false;
          this.bulkDetails = this.bulkDetails.filter((x) => x != type);
        }
      }
    } else {
      if (type == 'All') {
        this.bulkDetails = [];
        this.bulkData.forEach((x: any) => {
          if (checked) {
            x.isChecked = true;
            this.bulkDetails.push(x);
            this.hideButton = false;
          } else {
            this.hideButton = true;
            x.isChecked = false;
            this.bulkDetails = [];
          }
        });
      } else {
        if (checked) {
          type.isChecked = true;
          this.bulkDetails.push(type);
          this.hideButton = false;
        } else {
          type.isChecked = false;
          this.bulkDetails = this.bulkDetails.filter((x) => x != type);
        }
      }
    }
    this.selectAllAppCheck =
      this.bulkData.length == this.bulkDetails.length ? true : false;
    if (this.bulkDetails.length > 0) {
      this.hideButton = false;
    } else {
      this.hideButton = true;
    }
  }

  // Event Render Design
  renderEventContent(eventInfo: any, createElement: any) {
    let eventDetails = eventInfo.event._def.extendedProps;
    let status, title, start_time, end_time, classCovered, teacherCovered;

    // console.log('jnijnjuse', eventInfo);
    // Get the event's date in 'YYYY-MM-DD' format
    const eventDate = eventInfo.event.start
      ? eventInfo.event.start.toISOString().slice(0, 10)
      : '';
    // Check if this date is selected
    const isSelected =
      this.selectedDates && this.selectedDates.includes(eventDate);

    if (eventDetails.status == 'Booked') {
      status = 'Booked';
      title = eventDetails.booking.school.title;
      start_time = moment(eventDetails.start_time, 'HHmmss').format('HH:mm A');
      end_time = moment(eventDetails.end_time, 'HHmmss').format('HH:mm A');
    } else if (eventDetails.status == 'haventindicated') {
      status = 'haventindicated';
      title = "Haven't indicated";
      start_time = '';
      end_time = '';
    } else if (eventDetails.status == 'booked_externally') {
      status = 'booked_externally';
      title = 'Booked elsewhere';
      start_time = '';
      end_time = '';
    } else if (eventDetails.status == 'available') {
      status = 'available';
      title = 'Available';
      start_time = '';
      end_time = '';
    }else if (eventDetails.status == 'unavailable' && eventDetails?.from_roster == true) {
      status = 'roaster-unavailable';
      title = 'Contract Unavailable';
      start_time = '';
      end_time = '';   
    }else if (eventDetails.status == 'unavailable') {
      status = 'unavailable';
      title = 'Unavailable';
      start_time = '';
      end_time = '';
    } else if (eventDetails.status == 'drt_contract') {
      status = 'drt_contract';
      title = 'DRT Contract';
      start_time = '';
      end_time = '';
    } else if (eventDetails.status == 'lrt_contract') {
      status = 'lrt_contract';
      title = 'LRT Contract';
      start_time = '';
      end_time = '';
    } else if (eventDetails.status == 'Cancelled') {
      status = 'one_day_cancelled_teacher';
      title = 'Booking cancelled';
      start_time = '';
      end_time = '';
    }

    // Add the highlight class if selected
    let eventData = `<div class="col rendered-date event-indicator status-${status}${isSelected ? ' ' : ''
      }">`;
    // if (eventDetails.status == 'unavailable' && eventDetails?.from_roster == true) {
    //   eventData += '  <div class="event-wrapper">';
    //   eventData += '<div class="roaster_unavailable">R</div>';
    //   eventData += '</div>';
    // }
    eventData += `<p class="event-name">${title}</p>`;
    eventData += `</div>`;

    return (createElement = { html: eventData });
  }
  removeSelectedDate(date: string, type: string) {
    // console.log('Removing date:', date);
    // console.log('Selected modal dates before removal:', this.selectedDates);
    if (type === '') {
      const index = this.selectedDates.indexOf(date);
      if (index !== -1) {
        this.selectedDates.splice(index, 1);
        this.calendarComponent.getApi().render(); // Update calendar highlights
      }
      if(this.lrtDrtSelectedDates.length > 0){
        this.lrtDrtSelectedDates = this.lrtDrtSelectedDates.filter((event: any) =>
          moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') !== date
        );
      }
      if(this.roasterUnavailableSelectedDates.length > 0){
        this.roasterUnavailableSelectedDates = this.roasterUnavailableSelectedDates.filter((event: any) =>
          moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') !== date
        );
      }
      delete this.removedLrtDrtHalves[date];
      delete this.removedRoasterUnavailableHalves[date];
    } else if (type === 'recurring') {
      // console.log('Removing date:', date);
      // console.log(
      //   'Selected modal dates before removal:',
      //   this.selectedModalDates
      // );
      const index = this.selectedModalDates.indexOf(date);
      if (index !== -1) {
        this.selectedModalDates.splice(index, 1);
        this.datesToShow.splice(index, 1); // Remove from datesToShow as well
        this.calendarComponent.getApi().render(); // Update calendar highlights
      }
    }
    if (this.selectedDates.length === 0) {
      this.selectedDate = moment().format('YYYY-MM-DD');
      this.bookingList = [];
      this.isBookedExternally = false;
      this.showHalfDayBookings = false;
      // this.checkEventsOnDateClick(this.eventList, this.selectedDate);
      this.showSideDate = moment().format('MMMM DD, YYYY');
    }
  }

  // Calendar Type Changed Event
  changeCalendarType(eventData: any) {
    // console.log(eventData)
    let calendarApi = this.calendarComponent.getApi();
    this.calendarType = eventData;
    if (eventData == 'week') {
      calendarApi.changeView('dayGridWeek');
      this.setCalendatEvents(new Date());
      let getDates = this.weekStartEndDate(calendarApi.getDate());
      this.getCalendarData(getDates.startDate, getDates.endDate);
    } else {
      calendarApi.changeView('dayGridMonth');
      this.setCalendatEvents(new Date());
      let getDates = this.monthStartEndDate(calendarApi.getDate());
      this.getCalendarData(getDates.startDate, getDates.endDate);
    }
  }

  // Get Month Start & End Date
  monthStartEndDate(date: any) {
    let startDate = moment(date).startOf('month').format('YYYY-MM-DD');
    let endDate = moment(date).endOf('month').add(1, 'd').format('YYYY-MM-DD');
    let startEndDate;
    return (startEndDate = { startDate, endDate });
  }

  // Get Week Start & End Date
  weekStartEndDate(date: any) {
    let startDate = moment(date).startOf('week').format('YYYY-MM-DD');
    let endDate = moment(date).endOf('week').format('YYYY-MM-DD');
    let startEndDate;
    return (startEndDate = { startDate, endDate });
  }

  // Get Calendar Events
  getCalendarData(startDate: any, endDate: any, defaultDate?: any) {
    // this.closeConfirmModal();
    const dateObj = new Date(startDate);
    this.current_month = dateObj.toLocaleString('en-US', { month: 'short' });
    // console.log('Current Month:', this.current_month);
    const selectedDateForView = defaultDate || new Date();
    this.ngxService.start();
    this.CalendarService.calendarAPI(startDate, endDate).subscribe({
      next: (res: any) => {
        if (res.status) {
          // console.log('k', res.data)
          this.eventList = res.data;
          this.setCalendatEvents(selectedDateForView);
          this.showBookingDetailsForDate(moment(selectedDateForView).format('YYYY-MM-DD'));
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
    // Use the calendar's current view date for year and month
    const calendarApi = this.calendarComponent.getApi();
    const currentViewDate = calendarApi.getDate();
    const year = currentViewDate.getFullYear();
    const monthShort = currentViewDate.toLocaleString('en-US', { month: 'short' });
    const monthIndex = currentViewDate.getMonth() + 1;

    this.teacherBookingService.getTeacherSideComponentAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.sideComponentData = res.data;
        } else {
          this.toastr.error(res.message || 'Failed to load side panel data');
        }
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error('Something went wrong');
      }
    });
    this.CalendarService.calendarStatsAPI(monthIndex, year).subscribe({
      next: (res: any) => {
        if (res.status) {
          // console.log('k', res.data)
          this.stats = res.data;
          this.setCalendatEvents(selectedDateForView);
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
  }

  // Get Form Controls for html validations
  get f(): { [key: string]: AbstractControl } {
    return this.addExternalEventForm.controls;
  }

  onOpenCalendar(container: any) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
      // console.log(this.monthStartEndDate(event.date))
    };
    container.setViewMode('month');
  }

  changeCalendarMonth() {
    this.ngxService.start();
    let getDates = this.monthStartEndDate(this.calendarMonthSelection);
    // console.log(getDates);
    // return;
    let calendarApi = this.calendarComponent.getApi();
    calendarApi.gotoDate(this.calendarMonthSelection);
    this.getCalendarData(getDates.startDate, getDates.endDate);
    this.ngxService.start();
  }
  getCalenderBookings() {
    this.selectedDates = [];
    this.selectedDate = moment().format('YYYY-MM-DD');
    this.bookingList = [];
    this.isBookedExternally = false;
    this.showHalfDayBookings = false;
    this.closeConfirmModal();
    // this.checkEventsOnDateClick(this.eventList, this.selectedDate);
    this.showBookingDetailsForDate(this.selectedDate);
    this.ngxService.start();
    var dateVal = this.bsValue ? moment(this.bsValue).format('DD-MM-YYYY') : '';
    this.calendarBookingFilterForm.patchValue({
      select_date: dateVal,
    });
    this.CalendarService.calendarbookingDetailsAPI(
      this.calendarBookingFilterForm.value
    ).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.bookingTabDetails = res.data;
          this.availability_check = res.availability_check;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message, 'Error');
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
    this.teacherBookingService.getTeacherSideComponentAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.sideComponentData = res.data;
        } else {
          this.toastr.error(res.message || 'Failed to load side panel data');
        }
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error('Something went wrong');
      }
    });
  }

  ngAfterViewChecked() {
    // Remove the class from all cells first
    document
      .querySelectorAll('.fc-day.selected-calendar-date')
      .forEach((cell) => {
        cell.classList.remove('selected-calendar-date');
      });

    // console.log('Selected Dates in ngAfterViewChecked:', this.selectedDates);
    // Add the class only to selected dates
    this.selectedDates.forEach((dateStr) => {
      const cell = document.querySelector(`.fc-day[data-date="${dateStr}"]`);
      if (cell) {
        cell.classList.add('selected-calendar-date');
      }
    });
  }
  // set checkbox selected teachers
  setCheckbox(event: any, type: any) {
    var checked = event.target.checked;
    if (type == 'All') {
      this.consumerDetails = [];
      this.bookingDetails.forEach((x: any) => {
        if (checked) {
          x.booking.forEach((checkbox: any) => {
            checkbox.isChecked = true;
            this.consumerDetails.push(checkbox);
          });
          this.hideButton = false;
        } else {
          this.hideButton = true;
          x.booking.forEach((checkbox: any) => {
            checkbox.isChecked = false;
          });
          this.consumerDetails = [];
        }
      });
    } else {
      if (checked) {
        type.isChecked = true;
        this.consumerDetails.push(type);
        this.selectAllCheck = false;
        this.hideButton = false;
      } else {
        type.isChecked = false;
        this.consumerDetails = this.consumerDetails.filter((x) => x != type);
        this.selectAllCheck = false;
      }
    }

    this.selectAllCheck =
      this.bookingDetails.length == this.consumerDetails.length ? true : false;
    if (this.consumerDetails.length > 0) {
      this.hideButton = false;
    } else {
      this.hideButton = true;
    }
  }

  sendMessage(teacher: any) {
    const initialState = {
      teacher: teacher,
      from: '',
    };
    this.bsModalRef = this.modalService.show(SendMailComponent, {
      initialState,
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  // send email modal
  sendMail() {
    const initialState = {
      teacher: Array.prototype.map
        .call(this.consumerDetails, function (item) {
          return item.notification.consumer.id;
        })
        .join(','),
      from: 'find_new',
      all_checkbox: true,
      checked_status: this.consumerDetails,
    };
    this.bsModalRef = this.modalService.show(SendMailComponent, {
      initialState,
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  getFilterInputs() {
    this.ngxService.start();
    this.bookingService
      .calendarbookingDetails(this.getcalendarBookingFilterFormValues())
      .subscribe({
        next: (res: any) => {
          this.bookingDetails = res.data;
          this.ngxService.stop();
        },
        error: (err: any) => {
          this.ngxService.stop();
          console.log(err);
        },
      });
  }

  getcalendarBookingFilterFormValues() {
    let inlineEndDate = new DatePipe('en-US').transform(
      this.bsValue,
      'dd/MM/YYYY'
    );
    this.calendarBookingFilterForm.patchValue({
      date: inlineEndDate,
    });
    return this.calendarBookingFilterForm.value;
  }

  setActiveTab(tab: boolean) {
    this.activeTab = tab;
  }

  setSubActiveTab(tab: string) {
    if (tab === 'selected') {
      this.content = 'bookings';
    } else {
      this.content = 'availability';
    }
  }
  getBulkDataFormValue() {
    this.getBulkDataForm.patchValue({
      from_date: moment(this.bsBulkFromValue).format('DD/MM/YYYY'),
      to_date: moment(this.bsBulkToValue).format('DD/MM/YYYY'),
    });
    return this.getBulkDataForm.value;
  }
  sendBulkDataFormValue() {
    this.editBookings.patchValue({
      line_item_ids: Array.prototype.map
        .call(this.bulkDetails, function (item) {
          return item.id;
        })
        .join(','),
    });
    return this.editBookings.value;
  }

  getBulkEditData(event: any) {
    if (event == '') {
      if (
        this.bsBulkFromValue == '' ||
        (this.bsBulkFromValue == undefined && this.bsBulkToValue == '') ||
        this.bsBulkToValue == undefined
      ) {
        this.toastr.error('Start date or end date cannot be empty');
        return;
      }
    }
    if (this.bsBulkToValue == '' || this.bsBulkToValue == undefined) {
      return;
    }
    if (this.bsBulkFromValue == '' || this.bsBulkFromValue == undefined) {
      this.toastr.error('Start date or end date cannot be empty');
      return;
    }
    this.ngxService.start();
    this.bookingService.bulkEditData(this.getBulkDataFormValue()).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.bulkData = res.data;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }
  openBulkConfrimModal() {
    this.bsModalRef.hide();
    this.bsModalRef = this.modalService.show(this.bulkEditConfirmModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
  getFormControlValues() {
    // this.cancelBookingRequestForm.patchValue({
    //   lineitem_id: Array.prototype.map
    //     .call(this.bulkDetails, function (item) {
    //       return item.id;
    //     })
    //     .join(','),
    // });
    return this.cancelBookingRequestForm.value;
  }

  updateBulkData(action: any) {
    if (action == 'bulk_edit') {
      this.ngxService.start();
      this.editBookings.patchValue({
        action: action,
      });
      this.bookingService
        .updateBulkDataApi(this.sendBulkDataFormValue())
        .subscribe({
          next: (res: any) => {
            if (res.status) {
              this.bulkData = res.data;
              this.toastr.success(res.message);
              this.bsModalRef.hide();
              this.bsBulkFromValue = '';
              this.bsBulkToValue = '';
              this.editBookings.reset();
              this.editBookings.patchValue({
                booking_absencereason: [''],
              });
              this.getBulkDataForm.patchValue({
                filter_name: [''],
                from_date: [''],
                to_date: [''],
              });
              this.bulkData = '';
              this.bulkDetails = [];
              this.resetCalendarOnEvent();
            } else {
              this.toastr.error(res.message);
              this.ngxService.stop();
            }
          },
          error: (err: any) => {
            this.ngxService.stop();
            console.log(err);
          },
        });
    } else if (action == 'bulk_delete') {
      this.Desubmitted = true;
      if (this.cancelBookingRequestForm.invalid) {
        return;
      }
      this.ngxService.start();
      this.cancelBookingRequestForm.patchValue({
        action: action,
      });
      this.bookingService
        .updateBulkDataApi(this.getFormControlValues())
        .subscribe({
          next: (res: any) => {
            if (res.status) {
              this.bulkData = res.data;
              this.toastr.success(res.message);
              this.cancelBookingRequestForm.reset();
              this.bsBulkFromValue = '';
              this.bsBulkToValue = '';
              this.formInit();
              this.checkLength();
              this.Desubmitted = false;
              this.bsModalRef.hide();
              this.getBulkDataForm.patchValue({
                filter_name: [''],
                from_date: [''],
                to_date: [''],
              });
              this.bulkData = '';
              this.bulkDetails = [];
            } else {
              this.toastr.error(res.message);
              this.ngxService.stop();
            }
          },
          error: (err: any) => {
            this.ngxService.stop();
            console.log(err);
          },
        });
    }
  }
  closeBulkModal() {
    this.bsBulkFromValue = '';
    this.bsBulkToValue = '';
    this.getBulkDataForm.patchValue({
      filter_name: [''],
      from_date: [''],
      to_date: [''],
    });
    this.bulkData = '';
    this.bulkDetails = [];
  }
  closeAvailConfirmModal() {
    this.bsModalRef.hide();
  }
  closeConfirmModal() {
    this.showAvailabilityModal = false;
    this.recurringUpdateForm.get('occurrence')?.disable();
    this.bsModalRef.hide();
    this.updateAvailabilityForm.reset();
    this.selected = [1]; // Only Monday checked

    const startToday = moment().format('DD/MM/YYYY');
    const endToday = moment().format('DD/MM/YYYY');
    this.recurringUpdateForm.patchValue({
      start_date: startToday,
      end_date: endToday,
      week_repeater: this.selected,
    });

    this.recurringUpdateForm.patchValue({
      recurrent_week: '1',
      occurrence: '0',
      // recurrent_end: [''],
      // recurrent_occurrence: [''],
    });
    this.updateAvailabilityForm.patchValue({
      days: '',
      availability: 'available',
      time: 'full-day',
    });
    this.selectedDates = [];
  }
  closeBulkEditModal() {
    this.bsModalRef.hide();
    this.editBookings.reset();
    this.editBookings.patchValue({
      booking_absencereason: [''],
    });
    this.bsBulkFromValue = '';
    this.bsBulkToValue = '';
    this.getBulkDataForm.patchValue({
      filter_name: [''],
      from_date: [''],
      to_date: [''],
    });
    this.bulkData = '';
    this.bulkDetails = [];
  }

  openBulkDeleteModal() {
    this.bsModalRef = this.modalService.show(this.cancelReasonModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
  get cm(): { [key: string]: AbstractControl } {
    return this.cancelBookingRequestForm.controls;
  }
  checkLength() {
    // let timing =
    //   this.cancelBookingRequestForm.controls['custom_cancel_msg'].value;
    // let charectorLength = this.ShowLenghtError - timing.length;
    // this.ShowLenght = charectorLength;
  }

  closeModal() {
    this.bsModalRef.hide();
    this.formInit();
    this.checkLength();
    this.submitted = false;
  }

  openAddnewModal() {
    this.bsModalRef = this.modalService.show(AddNewModalComponent, {
      class: 'modal-lg',
    });
  }

  getTime(event: any) {
    console.log(event);
  }
  openExportModal() {
    this.bsModalRef = this.modalService.show(this.exportModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  openCustomPicker() {
    this.is_openCustomPicker = true;
  }
  openCustomPickerRange() {
    this.is_openCustomPickerRange = true;
  }
  getExportControlValues() {
    return this.getExportForm.value;
  }
  getExportValue(getValue: any) {
    let startDate = new DatePipe('en-US').transform(getValue[0], 'yyyy-MM-dd');
    let endDate = new DatePipe('en-US').transform(getValue[1], 'yyyy-MM-dd');

    this.getExportForm.patchValue({
      from_date: startDate,
      to_date: endDate,
    });
  }

  exportCalandarData() {
    this.ngxService.start();
    this.downloadLink().subscribe((resp: any) => {
      var blob = new Blob([resp.body], { type: 'text/csv' });
      var url = window.URL.createObjectURL(blob);
      var anchor = document.createElement('a');
      // var anchor.download = "myList.csv";
      const contentDisposition = resp.headers.get('Content-Disposition');
      if (contentDisposition) {
        const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = fileNameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
          anchor.download = matches[1].replace(/['"]/g, '');
        }
      }
      anchor.href = url;
      anchor.click();
      this.ngxService.stop();
    });
  }

  downloadLink(): Observable<HttpResponse<Blob>> {
    this.ngxService.start();
    return this.httpClient.get<Blob>(
      environment.apiUrl + 'api/v1/school-user/export-booking/',
      {
        params: this.getExportControlValues(),
        observe: 'response',
        responseType: 'blob' as 'json',
      }
    );
  }

  // this.bookingService.exportBookingsAPI(this.getExportControlValues()).subscribe({
  //   next: (res: any) => {
  //     this.ngxService.stop();
  //   },
  //   error: (err: any) => {
  //     this.ngxService.stop();
  //     this.toastr.error(err.message);
  //     console.log(err);
  //   }

  // });

  setEventRangeValue(event: any) {
    this.eventRangeValue = event;
  }

  closeDateRange() {
    var startFrom = moment(this.eventRangeValue[0]).format('DD/MM/YYYY');
    var endFrom = moment(this.eventRangeValue[1]).format('DD/MM/YYYY');
    // Set hours
    let startTime = moment(this.startTime).format('hh:mm A');
    let endTime = moment(this.endTime).format('hh:mm A');

    let startDate = moment(
      startFrom + ' ' + startTime,
      'DD/MM/YYYY hh:mm A'
    ).format('DD/MM/YYYY hh:mm A');
    let endDate = moment(endFrom + ' ' + endTime, 'DD/MM/YYYY hh:mm A').format(
      'DD/MM/YYYY hh:mm A'
    );
    // console.log(startDate, 'startDate');
    // console.log(endDate, 'endDate');
    this.addExternalEventForm.patchValue({
      start_end_date: startDate + ' - ' + endDate,
    });
    this.is_openCustomPickerRange = false;
  }

  closeExternalModal() {
    this.addExternalEventForm.reset();
    this.submitted = false;
    this.is_openCustomPickerRange = false;
    this.bsModalRef.hide();
  }

  reOpenBooking(id: any, line_id: any) {
    // this._router.navigate(['/school/post-job/'], { queryParams: { type: 'postCallOut' } });

    this._router.navigate(['/school/bookings/booking-request/rebook/' + id], {
      queryParams: { lineId: line_id },
    });
  }
  openbookingDetails(bookingDetails: any) {
    // console.log(bookingDetails)
    this.details = bookingDetails;
  }
  showHiddenDivOnclick() {
    this.showHiddenDiv = !this.showHiddenDiv;
  }

  cancelReason(cancelReasonModal: TemplateRef<any>) {
    this.cancelReasonModal = this.modalService.show(cancelReasonModal, {
      class: 'modal-md',
      backdrop: 'static',
    });

    // this.bsModalRef = this.modalService.show(this.cancelReasonModal, { class: 'modal-md', backdrop: 'static' });
  }
  updateAvailability(type: any) {
    if (type === 'recurring') {
      if (this.recurringUpdateForm.value.week_repeater === '') {
        this.toastr.error('Select at least one day');
        return;
      }
      this.updateAvailabilityAPI('recurring');
    } else {
      this.updateType = type;
      this.bsModalRef = this.modalService.show(this.updateAvailabilityModal, {
        class: 'modal-md',
        backdrop: 'static',
      });
    }
  }

  updateAvailabilityIndividual() {
    const individual_dates: any[] = [];

    this.selectedDates.forEach((days) => {
      const isLrtDrtDate = this.lrtDrtSelectedDates.some(
        (event: any) =>
          moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === days
      );

      // Split LRT/DRT half-days into their own entries instead of one combined full-day entry.
      // (A half may also be alone here if its counterpart half was removed or already booked.)
      if (isLrtDrtDate) {
        const rows = this.getLrtDrtDayRows(days);
        const isFullDayRow = rows.length === 1 && rows[0].label === 'Full day';

        if (!isFullDayRow) {
          rows.forEach((row) => {
            individual_dates.push(
              row.isContract
                ? {
                    days,
                    availability: 'unavailable',
                    time: row.halfValue,
                    external_school: '',
                    external_contact: '',
                    reason_for_absence:
                      this.individualAvailability[days]?.['reason_for_absence'] || '',
                  }
                : {
                    days,
                    ...this.individualAvailability[days],
                    time: row.halfValue,
                  }
            );
          });
          return;
        }
      }

      const isRoasterUnavailableDate = this.roasterUnavailableSelectedDates.some(
        (event: any) =>
          moment(event.date, 'DD/MM/YYYY').format('YYYY-MM-DD') === days
      );

      // Split "Revert contract days" half-days into their own entries the same way.
      if (isRoasterUnavailableDate) {
        const rows = this.getRoasterUnavailableDayRows(days);
        const isFullDayRow = rows.length === 1 && rows[0].label === 'Full day';

        if (!isFullDayRow) {
          rows.forEach((row) => {
            individual_dates.push(
              row.isRoasterUnavailable
                ? {
                    days,
                    availability: 'revert-back',
                    time: row.halfValue,
                    external_school: '',
                    external_contact: '',
                    reason_for_absence: '',
                  }
                : {
                    days,
                    ...this.individualAvailability[days],
                    time: row.halfValue,
                  }
            );
          });
          return;
        }
      }

      individual_dates.push({
        days,
        ...this.individualAvailability[days],
      });
    });

    const payload = { individual_dates };

    this.ngxService.start();
    this.CalendarService.updateAvailabilityAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.bsModalRef.hide();
          this.selectedModalDates = [];
          this.selectedDates = [];
          this.lrtDrtSelectedDates = [];
          this.normalSelectedDates = [];
          this.roasterUnavailableSelectedDates = [];
          this.removedLrtDrtHalves = {};
          this.removedRoasterUnavailableHalves = {};
          this.showAvailabilityModal = false;
          this.formInit();
          this.closeConfirmModal();
          this.datesOnLoad();
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }

  updateAvailabilityAPI(type: any) {
    if (type === 'individual_dates') {
      const payload = this.individualDatesForm.value; // Array of {date, availability, time}
      this.ngxService.start();

      this.CalendarService.updateAvailabilityAPI(
        this.updateAvailabilityForm.value
      ).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.toastr.success(res.message);
            this.bsModalRef.hide();
            this.datesOnLoad();
            this.ngxService.stop();
          } else {
            this.toastr.error(res.message);
            this.ngxService.stop();
          }
        },
        error: (err: any) => {
          this.ngxService.stop();
          console.log(err);
        },
      });
    } else if (type === 'half_day') {
      const payload = this.individualDatesForm.value; // Array of {date, availability, time}
      this.ngxService.start();

      this.CalendarService.updateAvailabilityAPI(
        this.updateAvailabilityForm.value
      ).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.toastr.success(res.message);
            this.bsModalRef.hide();
            this.whichHalfDayBookings = '';
            this.showHalfDayBookings = false;
            this.updateAvailabilityForm.patchValue({
              days: '',
              availability: 'available',
              time: 'full-day',
            });
            this.datesOnLoad();
            this.ngxService.stop();
          } else {
            this.toastr.error(res.message);
            this.ngxService.stop();
          }
        },
        error: (err: any) => {
          this.ngxService.stop();
          console.log(err);
        },
      });
    } else {
      if (type === 'recurring') {
        // console.log('Selected Modal Dates:', this.selectedModalDates);
        this.updateAvailabilityForm.patchValue({
          days: this.selectedModalDates.toString(),
        });
      } else {
        this.updateAvailabilityForm.patchValue({
          days: this.selectedDates.toString(),
        });
      }
      this.ngxService.start();

      this.CalendarService.updateAvailabilityAPI(
        this.updateAvailabilityForm.value
      ).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.toastr.success(res.message);
            this.updateAvailabilityForm.reset();
            this.selectedModalDates = [];
            this.selectedDates = [];
            this.showAvailabilityModal = false;
            this.formInit();
            this.closeConfirmModal();
            this.updateAvailabilityForm.patchValue({
              days: '',
              availability: 'available',
              time: 'full-day',
            });
            this.selectedDates = [];
            this.datesOnLoad();

            this.ngxService.stop();
          } else {
            this.toastr.error(res.message);
            this.ngxService.stop();
          }
        },
        error: (err: any) => {
          this.ngxService.stop();
          console.log(err);
        },
      });
    }
    this.lrtDrtSelectedDates = [];
    this.normalSelectedDates = [];
    this.roasterUnavailableSelectedDates = [];
  }
  public parentForm: FormGroup = this.fb.group({
    individualDatesForm: this.fb.array([]),
  });
  get individualDatesForm(): FormArray {
    return this.parentForm.get('individualDatesForm') as FormArray;
  }
  updateIndividualDatesForm() {
    // Clear existing controls
    this.individualDatesForm.clear();
    // Add a FormGroup for each selected date
    this.selectedDates.forEach((date) => {
      this.individualDatesForm.push(
        this.fb.group({
          date: [date],
          availability: ['available', Validators.required],
          time: ['full-day', Validators.required],
        })
      );
    });
  }
  openRecurringUpdateModal() {
    this.bsModalRef = this.modalService.show(this.recurringUpdateModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
  selected: any[] = [1];
  // check if the item are selected
  checked(isChecked: any) {
    if (this.selected.indexOf(isChecked) != -1) {
      return true;
    }
    return false;
  }
  onChange(checked: any, isChecked: any) {
    let checkedData = checked.target.checked;
    if (checkedData) {
      this.selected.push(isChecked);
      this.recurringUpdateForm.patchValue({
        week_repeater: this.selected,
      });
    } else {
      this.selected.splice(this.selected.indexOf(isChecked), 1);
      this.recurringUpdateForm.patchValue({
        week_repeater: this.selected,
      });
    }
    if (this.selected.length == 0) {
      this.recurringUpdateForm.patchValue({
        week_repeater: '',
      });
    }

    return this.recurringUpdateForm.value;
  }
  recurringDatesMatch() {
    this.ngxService.start();
    // console.log(this.recurringUpdateForm.value);
    if (
      moment(
        this.recurringUpdateForm.value.end_date,
        'mm/dd/YYYY',
        true
      ).isValid()
    ) {
      let en_date = new DatePipe('en-US').transform(
        this.recurringUpdateForm.value.end_date,
        'dd/MM/YYYY'
      );
      this.recurringUpdateForm.patchValue({
        end_date: en_date,
      });
    }
    if (
      moment(
        this.recurringUpdateForm.value.start_date,
        'mm/dd/YYYY',
        true
      ).isValid()
    ) {
      let start_date = new DatePipe('en-US').transform(
        this.recurringUpdateForm.value.start_date,
        'dd/MM/YYYY'
      );
      this.recurringUpdateForm.patchValue({
        start_date: start_date,
      });
    }
    // console.log('Recurring Update Form Value:', this.recurringUpdateForm.value);
    this.CalendarService.recurringDatesMatchAPI(
      this.recurringUpdateForm.getRawValue()
    ).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.datesToShow = res.data;
          this.selectedModalDates = this.datesToShow.map(
            (date: any) => date.return_date
          );
          this.showAvailabilityModal = true;
          this.datesOnLoad();
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }
  backToRecurring() {
    this.showAvailabilityModal = false;
  }
  occurrenceChange(type: string) {

    if (type === '1') {
      this.recurringUpdateForm.get('end_date')?.disable();
      this.recurringUpdateForm.patchValue({
        recurrent_end: '2',
      });
      this.recurringUpdateForm.get('occurrence')?.enable();
      this.recurringUpdateForm.patchValue({
        recurrent_end: '2',
      });
      var endFrom = moment(this.recurringUpdateForm.value.end_date).format('DD/MM/YYYY');
      this.recurringUpdateForm.patchValue({
        end_date: endFrom,
      });

    } else {
      this.recurringUpdateForm.get('end_date')?.enable();
      this.recurringUpdateForm.patchValue({
        recurrent_end: '3',
      });
      this.recurringUpdateForm.get('occurrence')?.disable();
      this.recurringUpdateForm.patchValue({
        recurrent_end: '3',
      });
    }
    // console.log('Occurrence change:', type);
  }
  // Circular progress ring
  getSmallProfileDashOffset(availability_health: number): string {
    const r = 35;
    const circumference = 2 * Math.PI * r;
    const adjustedHealth = 100 - availability_health;
    const percent = Math.max(0, Math.min(100, adjustedHealth));
    const offset = circumference - (circumference * percent) / 100;
    return offset.toFixed(3);
  }

  getSmallProfileDashArray(availability_health: number): string {
    const r = 35;
    return (2 * Math.PI * r).toFixed(3);
  }

  goToCalendar(): void {
    this.router.navigate(['teacher/calendar']);
  }
  public isBookedExternally: boolean = false;

  onAvailabilityChange(event: any) {
    this.isBookedExternally = event.target.value === 'booked_externally';
  }
  onAvailabilityChangeHalf(event: any, halfDayIndicated: any) {
    // console.log('Half Day Indicated:', halfDayIndicated);
    this.isBookedExternally = event.target.value === 'booked_externally';
    const formattedDate = moment(halfDayIndicated.date, [
      'DD/MM/YYYY',
      'YYYY-MM-DD',
    ]).format('YYYY-MM-DD');

    if (this.isBookedExternally) {
      // Open the external booking modal
      this.bsModalRef = this.modalService.show(this.bookingExternalModal, {
        class: 'modal-md',
        backdrop: 'static',
      });
      if (halfDayIndicated.booking_range === 'second-half') {
        this.updateAvailabilityForm.patchValue({
          days: formattedDate,
          time: 'half-day-pm',
        });
      } else {
        this.updateAvailabilityForm.patchValue({
          days: formattedDate,
          time: 'half-day-am',
        });
      }
    } else {
      if (this.whichHalfDayBookings === 'Second half') {
        this.updateAvailabilityForm.patchValue({
          days: formattedDate,
          availability: event.target.value,
          time: 'half-day-pm',
        });
      } else {
        this.updateAvailabilityForm.patchValue({
          days: formattedDate,
          availability: event.target.value,
          time: 'half-day-am',
        });
      }
      this.updateAvailabilityAPI('half_day');
    }
    // Submit the form (call your submit function)
  }

  setGoogleMapsUrl(location: any): SafeResourceUrl {
    // Handles WKT POINT or address string
    if (typeof location === 'string' && location.startsWith('SRID=') && location.includes('POINT')) {
      // WKT POINT (lng lat)
      const match = location.match(/POINT\s*\(\s*([\d.-]+)\s+([\d.-]+)\s*\)/);
      if (match) {
        const lng = match[1];
        const lat = match[2];
        const url = `https://www.google.com/maps?q=${lat},${lng}&output=embed`;
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }
    }
    // Otherwise treat as address
    // const query = encodeURIComponent(location);
    // const url = `https://www.google.com/maps?q=${query}&output=embed`;
    return '';
  }
  openCancelModal() {
    const bookingDateStr = this.bookingDatas?.display_date;
    const bookingStartTimeStr = this.bookingDatas?.start_time;

    // Parse booking date and time
    const bookingDate = moment(bookingDateStr, 'dddd, MMM DD, YYYY');
    const bookingStartDateTime = moment(`${bookingDate.format('YYYY-MM-DD')} ${bookingStartTimeStr}`, 'YYYY-MM-DD HH:mm:ss');
    const now = moment();

    // Check if booking date is today and user is QLD school
    // if (bookingStartDateTime.isSame(now, 'day') && this.schoolProps.properties.is_qld_teacher) {
    if (bookingStartDateTime.diff(now, 'hours') < 24 && bookingStartDateTime.isAfter(now)) {
      // this.toastr.warning('This booking starts within the next 24 hours.');
      this.isOneDayBooking = true;
    } else {
      this.isOneDayBooking = false;
    }
    this.cancelBookingState = true;
    // this.bsModalRef = this.modalService.show(this.cancelReasonModal, {
    //   class: 'modal-md',
    //   backdrop: 'static',
    // });
  }

  updateGoogleMapFromBooking() {
    if (
      this.bookingDatas &&
      this.bookingDatas.booking &&
      this.bookingDatas.booking.school
    ) {
      const school = this.bookingDatas.booking.school;
      if (school.location) {
        this.googleMapsUrl = this.setGoogleMapsUrl(school.location);
      } else if (school.address && school.address.address_line) {
        const addressLine = school.address.address_line;
        this.googleMapsUrl = this.setGoogleMapsUrl(addressLine);
      }
    }
  }
  onDateChange(date: Date) {
    const formattedDate = moment(date).format('MM/DD/YYYY');
    this.calendarBookingFilterForm.get('select_date')?.setValue(formattedDate);
    if (this.activeTab === false) {
      this.getCalenderBookings();
    }
  }
  cancelBooking(lineitem_id: any) {
    this.submitted = true;
    this.cancelBookingRequestForm.get('cancel_message')?.markAsTouched();
    if (this.cancelBookingRequestForm.invalid) {
      return;
    }
    this.ngxService.start();
    this.cancelBookingRequestForm.patchValue({
      lineitem_id: lineitem_id,
    });
    this.CalendarService.cancelBookingsAPI(
      this.getFormControlValues()
    ).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.bsModalRef.hide();
          this.formInit();
          this.Desubmitted = false;
          this.datesOnLoad();
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.error?.message || 'Something went wrong');
        console.log(err);
      },
    });
  }
  updateExternalBookings() {
    this.ngxService.start();
    this.CalendarService.updateExternalBookingsAPI(
      this.bookingExternalForm.value
    ).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.bsModalRef.hide();
          this.datesOnLoad();

          this.submitted = false;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }

  deleteUpdateBooking() {
    this.ngxService.start();
    this.CalendarService.deleteUpdateBookingAPI(
      this.bookingExternalForm.value
    ).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.datesOnLoad();
          this.bsModalRef.hide();
          this.submitted = false;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }
  handlePageData(data: any) {
    // Store the page data for later use, e.g. pagination or display
    this.pageData = data;
    // Optionally, update the UI or trigger other logic if needed
    // Example: this.obsArray.next(data.consumer_list || []);
  }
  pageData: any;
}
